var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.5,
    cy: 37.5,
    r: 9.0600004,
    id: "circle186",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 63.36,37.55 c 0,0 -10.87,15.67 -25.86,15.67 C 22.75,53.02 11.64,37.55 11.64,37.55 v -0.1 c 0,0 11.11,-15.47 25.86,-15.67 14.99,0 25.86,15.67 25.86,15.67 z",
    id: "path188-7",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenPin);
export default __webpack_public_path__ + "static/media/HiddenPin.b57498bca45a69715579b90b5d321c04.svg";
export { ForwardRef as ReactComponent };